import { render, staticRenderFns } from "./DeleteComponentGroupButton.vue?vue&type=template&id=3d8b8e22&scoped=true"
import script from "./DeleteComponentGroupButton.vue?vue&type=script&lang=js"
export * from "./DeleteComponentGroupButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8b8e22",
  null
  
)

export default component.exports